import { Controller } from "@hotwired/stimulus"

// Opens an Expert's Insight clip in a dimmed overlay (lightbox) on the lesson
// reader. The overlay holds the block's audio/video player (the shared
// media-player engine); opening starts playback, closing pauses it. Closes on
// a backdrop click, the close button, or Escape; locks body scroll while open
// and restores focus to the thumbnail that was clicked.
export default class extends Controller {
  static targets = ["overlay", "closeButton"]

  open(event) {
    this.lastFocused = event.currentTarget
    this.overlayTarget.hidden = false
    this.overlayTarget.setAttribute("aria-hidden", "false")
    // Add the visible class on the next frame so the opacity transition runs
    // from the just-unhidden state instead of being skipped.
    requestAnimationFrame(() => this.overlayTarget.classList.add("is-open"))
    document.body.style.overflow = "hidden"
    this.closeButtonTarget.focus()
    this.mediaElement?.play()?.catch(() => {})
  }

  close() {
    if (this.overlayTarget.hidden) return

    this.mediaElement?.pause()
    this.overlayTarget.classList.remove("is-open")
    this.overlayTarget.hidden = true
    this.overlayTarget.setAttribute("aria-hidden", "true")
    document.body.style.overflow = ""
    if (this.lastFocused) this.lastFocused.focus()
  }

  // Close only when the dimmed backdrop itself is clicked — clicking the player
  // (a child of the overlay) should keep the lightbox open.
  backdropClose(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  closeOnEscape() {
    if (!this.overlayTarget.hidden) this.close()
  }

  get mediaElement() {
    return this.overlayTarget.querySelector("audio, video")
  }
}
